// PricingPage.jsx
// Standalone detailed pricing and service comparison.

import React from "react";
import { SoyTiendaHeader } from "./shared/SoyTiendaHeader";
import { MarketplaceFooter } from "./shared/MarketplaceFooter";
import { WhatsAppFloat } from "./shared/WhatsAppFloat";
import { PreciosSection } from "./tienda/PreciosSection";

export default function PricingPage() {
  return (
    <div className="flex min-h-screen flex-col font-sans antialiased text-slate-900">
      <SoyTiendaHeader />
      <main className="flex-1">
        <PreciosSection />
      </main>
      <MarketplaceFooter />
      <WhatsAppFloat />
    </div>
  );
}
